import { Button, ButtonProps } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import _t from "../../../../lang/translate";

export function DetailsButton({ showDetails, className, style, ...rest }: ButtonProps & { showDetails: boolean }) {
  return (
    <Button type="text" size="small"
      className={"btn-text-primary-hover " + (className ?? "")}
      style={{ marginRight: -7, ...style }}
      icon={showDetails ? <EyeInvisibleOutlined /> : <EyeOutlined />}
      {...rest}
    >
      {_t("details")}
    </Button>

  )
}
